import React, { useState } from "react";
import PageHeader from "../../components/PageHeader";
import { Box, TextField, Button } from "@mui/material";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/PaymentCrudConfig.json";
function PaymentGateWayPage() {
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const handleApiKeyChange = (event) => {
    setApiKey(event.target.value);
  };

  const handleApiSecretChange = (event) => {
    setApiSecret(event.target.value);
  };

  const handleUpdate = () => {
    // You can implement your update logic here, like sending the API key and API secret to your backend
    console.log("API Key:", apiKey);
    console.log("API Secret:", apiSecret);
    // You can make API calls here to update the API key and secret in your backend
  };
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="paymentgateway"
        sx={{
          flexGrow: 1,
          marginTop: 0,
          marginLeft: 15,
          marginRight: 15,
          marginBottom: 15,
        }}
      >
        <PageHeader pageTitle="Payment Gateway" />
        <div
          className="container"
          style={{
            // width: "300px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {/* <div>
            <TextField
              type="password"
              label="API Key"
              name="api_key"
              value={apiKey}
              variant="standard"
              onChange={handleApiKeyChange}
              fullWidth
            />
          </div> */}
          {/* <div>
            <TextField
              type="password"
              label="API Secret"
              name="api_secret"
              value={apiSecret}
              variant="standard"
              onChange={handleApiSecretChange}
              fullWidth
            />
          </div> */}
          </div>
          {/* <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
            <Button onClick={handleUpdate} variant="contained" style={{backgroundColor:"#17202A" }}>Update</Button>
          </Box> */}
          <CrudManager
          data={schema}
          createRequired={true}
          // actionBtnName="Add New Role"
          // createFormTitle="Add Role"
          // updateFormTitle="Update Role"
        />
      </Box>
    </Box>
  );
}

export default PaymentGateWayPage;
